import script from "./certificates.vue?vue&type=script&setup=true&lang=js"
export * from "./certificates.vue?vue&type=script&setup=true&lang=js"

import "./certificates.vue?vue&type=style&index=0&id=7f750574&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f750574"]])

export default __exports__